import React from 'react'

export default function Version(props) {
  return (
    <>
        <div className="Version_popup" id={props.versionid}>
            <div className="close_model"></div>
            <div className="case_detail version-sumry">
                <div className="caseimg">
                    <div className="name">announcing our version 3.0</div>
                    <p className='text-white fs-12'>We’re proud to announce our most powerful release yet—byteEDGE Version 3.0. Packed with meaningful innovations and thoughtful enhancements, this release is designed to supercharge workforce capability development and future proof your investments with us.</p>
                </div>
                <div className="summary">
                    <h4>Major New AI Advancements</h4>
                    <ul className='bullet_points'>
                        <li><b>AI Role Play Practice Simulations (Pro License Exclusive):-</b> The ultimate competency builder—practice real-life business conversations through AI-driven simulations. Perfect for developing communication skills, customer facing skills like negotiation and customer services skills like  empathy, and more. Learners receive AI-generated feedback, actionable coaching advice, smart tips and scores, helping identify skill gaps. Now available exclusively to Pro users. Talk to us to learn more.</li>
                        <li><b>Meet BEKA – Your AI Knowledge Assistant:-</b> BEKA is our voice-based AI assistant that understands natural language and answers questions from your enterprise’s uploaded documents, SOPs, manuals, and guides. This boosts employee self-service, knowledge accessibility, and productivity—instantly.</li>
                        <li><b>AI-Powered 24/7 Support for All Users:-</b> We’re redefining learner support with our always-available AI helpdesk. Users can raise tickets or get instant assistance via chat, reducing resolution time and enhancing user satisfaction.</li>
                    </ul>
                    <h4>Other Major Enhancements</h4>
                    <ul className="bullet_points">
                    <li><b>Global Elastic Search Across Content Types:</b> Our search is now smarter and deeper—covering not just courses, but also documents, social posts, and user-generated content. byteEDGE becomes your single source of truth for learning and information retrieval.</li>
                    
                    <li><b>Manager-Led Learning – New ‘Assign’ Button:</b> Managers can now assign courses directly to team members, simplifying capability building and performance alignment.</li>

                    <li><b>Ratings, Reviews & Feedback:</b> Capture real-time learner sentiment across courses, learning journeys, and webinars.</li>
                    </ul>

                    <h4>Additional Enhancements Include</h4>
                    <ul className="bullet_points">
                    <li><b>Share Button for Reels and Courses:</b> Promote viral learning through easy peer-to-peer content sharing.</li>

                    <li><b>Deeper Content Segmentation:</b> Improved navigation via new sub-category classifications on the Discover page.</li>

                    <li><b>QR Code Attendance & Training Ops:</b> Manage training efficiently with QR-based attendance, resource uploads, ticketing, and team assignments.</li>

                    <li><b>Revamped 'Learn' Section:</b> Unified access to assignments, mentoring, AI recommendations, journeys, and knowledge content in one place.</li>

                    <li><b>New 'Reflect' Section:</b> Engage with simulations, surveys, polls, and self-assessments to encourage self-awareness and growth.</li>

                    <li><b>Next-Gen Learner Profiles:</b> Gamified learning with goals, karma points, leaderboards, and progress dashboards—like a Fitbit for learning.</li>

                    <li><b>Smart Skipping for Learning Journeys:</b> Skip previously completed modules to stay efficient and relevant.</li>

                    <li><b>Push Notifications (Web/Desktop):</b> Keep learners updated with real-time nudges, alerts, and reminders.</li>
                    </ul>

                </div>
            </div>
        </div>
    </>
  )
}
